<script setup lang="ts">
/** PATCH name on any entity (dataset, collection, endpoint). One field, hard cap 120. */
import Dialog from '~/components/ui/Dialog.vue'
import Field from '~/components/ui/Field.vue'
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'

const props = defineProps<{ entity: string; current: string; kind: string }>()
defineEmits<{ close: []; submit: [payload: Record<string, unknown>] }>()
const name = ref(props.current)
const error = computed(() => name.value.trim().length === 0 ? 'A name is required' : name.value.trim().length > 120 ? 'Up to 120 characters' : '')
</script>

<template>
  <Dialog :title="'Rename ' + kind" :meta="entity" :width="440" @close="$emit('close')">
    <template #icon><Icon name="pen" /></template>
    <Field v-model="name" label="Name" :error="error" hint="Links and exports keep working · the id does not change" />
    <template #actions>
      <ActionButton label="Cancel" @click="$emit('close')" />
      <ActionButton label="Rename" variant="primary" :disabled="!!error" @click="$emit('submit', { name: name.trim() })"><template #icon><Icon name="check" /></template></ActionButton>
    </template>
  </Dialog>
</template>
